export enum EAbondancePeriphyton {
    Absent = 1,
    PeuAbondant = 2,
    Abondant = 3,
    TresAbondant = 4,
}